import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { UI } from "./ui";

const LanguageContext = createContext({ lang: "es", t: UI.es, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const stored = localStorage.getItem("onix_lang");
      return stored === "en" ? "en" : "es";
    } catch {
      return "es";
    }
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    setLangState(l);
    try {
      localStorage.setItem("onix_lang", l);
    } catch {
      /* noop */
    }
  }, []);

  return <LanguageContext.Provider value={{ lang, t: UI[lang], setLang }}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
